export default "__VITE_ASSET__CLddCwvP__"